module.exports = __webpack_public_path__ + "media/images/mailer/confirmation_email_04-139b234b6396db7f22aa0606721a873f.png";